import { api } from '../lib/api';
import { dateTime, localZoneLabel } from '../lib/format';
import { Card, Empty, ErrorNote, Loading, PageHead, useResource } from '../components/ui';

/** CM-9 administrative audit log: who changed what, and what it looked like before. */

interface Entry {
  id: string;
  actor: string;
  action: string;
  entity: string;
  entity_id: string | null;
  before: unknown;
  after: unknown;
  ip: string | null;
  at: string;
}

export default function AuditLog() {
  const { data, error, loading } = useResource<{ entries: Entry[] }>(() => api.get('/v1/audit?limit=200'));

  return (
    <>
      <PageHead
        title="Audit log"
      />

      <ErrorNote error={error} />
      {loading && !data && <Loading what="Loading audit log" />}

      {data && (data.entries.length === 0 ? (
        <Empty>Nothing recorded yet.</Empty>
      ) : (
        <Card>
          <div className="table-scroll">
            <table className="data">
              <thead>
                <tr>
                  <th>When ({localZoneLabel()})</th>
                  <th>Actor</th>
                  <th>Action</th>
                  <th>Entity</th>
                  <th>Change</th>
                </tr>
              </thead>
              <tbody>
                {data.entries.map((e) => (
                  <tr key={e.id}>
                    <td className="mono small">{dateTime(e.at)}</td>
                    <td className="small" title={e.ip ?? undefined}>{e.actor}</td>
                    <td className="mono small">{e.action}</td>
                    <td className="small" title={e.entity_id ?? undefined}>{e.entity}</td>
                    <td>
                      {e.before || e.after ? (
                        <details>
                          <summary className="small muted" style={{ cursor: 'pointer' }}>view</summary>
                          <pre className="mono" style={{ whiteSpace: 'pre-wrap', maxWidth: 460, marginTop: 6 }}>
                            {e.before ? `before: ${JSON.stringify(e.before, null, 2)}\n` : ''}
                            {e.after ? `after:  ${JSON.stringify(e.after, null, 2)}` : ''}
                          </pre>
                        </details>
                      ) : (
                        <span className="muted small">—</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      ))}
    </>
  );
}
